import { useTranslation } from 'react-i18next';

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-28 px-5 md:px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20navy%20blue%20technology%20background%20with%20glowing%20electric%20blue%20neon%20lines%20and%20digital%20circuit%20patterns%2C%20futuristic%20tech%20aesthetic%2C%20deep%20dark%20gradient%20with%20cyan%20accents%2C%20minimalist%20digital%20art%2C%20no%20people%2C%20ultra%20high%20quality&width=1920&height=600&seq=cta001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0" style={{ backgroundColor: 'rgba(2,8,23,0.87)' }}></div>
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(0,207,255,0.04), transparent, rgba(0,207,255,0.04))' }}></div>
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{ backgroundColor: 'rgba(0,207,255,0.04)', filter: 'blur(80px)' }}></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="aw font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-4 md:mb-6 leading-tight">
          {t('cta_title_1')}<br />
          <span style={{ background: 'linear-gradient(90deg, #00cfff, #00ff9d)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{t('cta_title_2')}</span>
        </h2>
        <p className="aw-65 font-body text-sm md:text-lg mb-7 md:mb-10 max-w-xl mx-auto leading-relaxed">
          {t('cta_sub')}
        </p>

        <a
          href="#book-demo"
          className="inline-flex items-center gap-2 md:gap-3 bg-electric hover:bg-electric/85 text-navy-950 font-bold text-sm md:text-base px-7 md:px-10 py-3.5 md:py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap font-body"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-calendar-schedule-line text-lg"></i>
          </div>
          {t('cta_calendar')}
        </a>

        <p className="aw-40 font-body text-xs mt-4 md:mt-6">
          {t('cta_footer')}
        </p>
      </div>
    </section>
  );
}
